import { Navigate, Outlet } from "react-router-dom";

import { Layout } from "@/components/layout";
import { useAuth } from "@/hooks/useAuth";
import { LoadingSpinner } from "@/presentation/components/LoadingSpinner";

export function RequireAuth() {
  const { isAuthenticated, isLoading } = useAuth();

  // Mostrar loading enquanto verifica autenticação
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  // Verificar autenticação pelo estado do context (mais confiável)
  if (!isAuthenticated) {
    // Limpar qualquer dado residual
    localStorage.removeItem("user");
    localStorage.removeItem("access_token");
    return <Navigate to="/login" replace />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
